import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    width: 183px;

    background: ${Colors.Black.V100};
    border-radius: 6px;
`;

export const Header = styled.div`
    ${Fonts.Heading.H600}
    padding: 6px 0 6px 12px;

    color: ${Colors.WHITE};

    background-color: ${Colors.Black.V200};
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
`;

export const Body = styled.div`
    display: flex;
    padding: 12px 0;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
`;

export const ActiveDot = styled.span`
    width: 5px;
    height: 5px;
    margin: 2px 9px 0;

    background-color: ${Colors.Yellow.V200};
    border-radius: 50%;
`;

export const TextBox = styled.div`
    display: flex;
    flex-direction: column;

    &:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const Label = styled.span`
    ${Fonts.Heading.H800}
    color: ${Colors.Gray.V100};
`;

export const Value = styled.span`
    ${Fonts.Heading.H700}
    color: ${Colors.WHITE};
`;
